export enum WMTDisconnectReason {
  BadFormat = 'BF',
  BadSignature = 'BS',
  InvalidMessageType = 'MT',
  InvalidSessionId = 'IS',
  InvalidSubscriptionDestination = 'ID',
  InvalidToken = 'IT',
  MaxSubscriptionExceeded = 'MS',
  TokenRequired = 'TR',
  UnknownOrigin = 'UO',
  UserChangeNotAllowed = 'UC',
  VelocityControl = 'VC'
}
